import { useMutation } from '@tanstack/react-query';
import { AwardsService } from '../services';

/**
 * Export download is imperative (it returns a blob), so it is modelled as a
 * mutation rather than a query. The caller's onSuccess receives
 * { blob, filename } and is responsible for saving the file to disk.
 */
export const useDownloadCycleExport = (options = {}) => {
  const { onSuccess, onError } = options;

  return useMutation({
    // A failed download is surfaced inline by the caller, so nothing here
    // should reach the global toaster.
    meta: { skipGlobalErrorToaster: true },
    mutationFn: (params) => AwardsService.downloadCycleExport(params),
    // Narrowed to the { blob, filename } payload so callers don't couple to
    // react-query's variables/context args (matches useDownloadPayoutReport).
    onSuccess: (data) => onSuccess?.(data),
    onError,
  });
};
